import { useCallback, useContext } from "react";
import { DTFocusDispatchContext } from "./DTFocusContext";
import { CellPosition } from "../../../../internal/types";

export function useDTFocusDispatchContext() {
  const dispatch = useContext(DTFocusDispatchContext);

  const focusTableGenerally = useCallback(() => {
    dispatch({
      type: "FOCUS_TABLE",
    });
  }, [dispatch]);

  const moveFocusToCell = useCallback(
    (cellPosition: CellPosition) => {
      dispatch({
        type: "FOCUS_CELL",
        payload: { cellPosition },
      });
    },
    [dispatch],
  );

  /**
   * Moves the focus to the next valid cell in the given direction
   */
  const moveFocus = useCallback(
    (direction: "up" | "down" | "left" | "right") => {
      dispatch({
        type: "MOVE_FOCUS",
        payload: { direction },
      });
    },
    [dispatch],
  );

  /**
   * Moves the focus to the first/last valid cell in the given direction
   */
  const jumpFocus = useCallback(
    (direction: "up" | "down" | "left" | "right") => {
      dispatch({
        type: "JUMP_FOCUS",
        payload: { direction },
      });
    },
    [dispatch],
  );

  const blur = useCallback(() => {
    dispatch({
      type: "BLUR",
    });
  }, [dispatch]);

  const focusSubComponent = useCallback(() => {
    dispatch({ type: "FOCUS_SUB_COMPONENT" });
  }, [dispatch]);

  const blurSubComponent = useCallback(() => {
    dispatch({ type: "BLUR_SUB_COMPONENT" });
  }, [dispatch]);

  return {
    focusTableGenerally,
    moveFocusToCell,
    moveFocus,
    jumpFocus,
    blur,
    focusSubComponent,
    blurSubComponent,
    dispatch,
  };
}
